import Vue from 'vue';
import Router from 'vue-router';
import Login from "@/viewer/Login";
import AuthBusiness from "@/business/AuthBusiness";
import PublicClientForm from "@/viewer/public-client-form/PublicClientForm";
import PublicClientProtocolInfo from "@/viewer/public-client-form/PublicClientProtocolInfo";
import Error from "@/viewer/Error";
import { ADMINISTRATOR, NORMAL, LIMITED } from "@/constants/TypeUser";

Vue.use(Router);

export const router = new Router({
	routes: [
		{
			path: '',
			alias: '/',
			name: 'home',
			redirect: '/dashboard',
			meta: { authentication: { requiresAuth: true } },
			component: () => import('@/Layout'),

			children: [
				{
					path: '/dashboard',
					name: 'dashboard',
					component: () => import('@/viewer/Dashboard.vue')
				},
				{
					path: '/account',
					name: 'account',
					component: () => import('@/viewer/user/Account.vue')
				},
			],
		},
		{
			path: '',
			alias: '/',
			name: 'configuration',
			redirect: '/system-configuration',
			meta: { authentication: { requiresAuth: true, permissionLevel: ADMINISTRATOR } },
			component: () => import('@/Layout'),

			children: [
				{
					path: '/system-configuration',
					name: 'system-configuration',
					component: () => import('@/viewer/system-configuration/SystemConfiguration')
				},
				{
					path: '/login-page-configuration',
					name: 'login-page-configuration',
					component: () => import('@/viewer/system-configuration/LoginPageConfiguration')
				},
			],
		},
		{
			path: '',
			alias: '/',
			redirect: '/user',
			meta: { authentication: { requiresAuth: true, permissionLevel: ADMINISTRATOR } },
			component: () => import('@/Layout'),
			children: [
				{
					path: '/user/list',
					meta: { group: 'user'},
					name: 'userList',
					component: () => import('@/viewer/user/UserList.vue')
				},
				{
					path: '/user/:id?',
					meta: { group: 'user'},
					name: 'user',
					component: () => import('@/viewer/user/UserForm.vue')
				}
			]
		},
		{
			path: '',
			alias: '/',
			redirect: '/client',
			meta: { authentication: { requiresAuth: true } },
			component: () => import('@/Layout'),
			children: [
				{
					path: '/client/list',
					meta: { group: 'client'},
					name: 'clientList',
					component: () => import('@/viewer/client/ClientList.vue')
				},
				{
					path: '/client/:id?',
					meta: { group: 'client'},
					name: 'client',
					component: () => import('@/viewer/client/ClientForm.vue')
				},
				{
					path: '/client/:id?/:tab?',
					meta: { group: 'client'},
					name: 'clientDetails',
					component: () => import('@/viewer/client/Client.vue')
				},
			]
		},
		{
			path: '',
			alias: '/',
			redirect: '/protocol',
			meta: { authentication: { requiresAuth: true } },
			component: () => import('@/Layout'),
			children: [
				{
					path: '/protocol-list',
					meta: { group: 'protocol'},
					name: 'protocolList',
					component: () => import('@/viewer/protocol/ProtocolList.vue')
				},
				{
					path: '/budgets-list',
					meta: { group: 'protocol'},
					name: 'budgetsList',
					component: () => import('@/viewer/protocol/BudgetList.vue')
				},
				{
					path: '/protocol/form/:id?',
					meta: { group: 'protocol', authentication: { requiresAuth: true, permissionLevel: NORMAL }},
					name: 'protocolForm',
					component: () => import('@/viewer/protocol/ProtocolForm.vue')
				},
				{
					path: '/protocol/:id/:tab?',
					meta: { group: 'protocol'},
					name: 'protocol',
					component: () => import('@/viewer/protocol/Protocol.vue')
				}
			]
		},
		{
			path: '',
			alias: '/',
			redirect: '/type-service',
			meta: { authentication: { requiresAuth: true, permissionLevel: ADMINISTRATOR } },
			component: () => import('@/Layout'),
			children: [
				{
					path: '/type-service/list',
					meta: { group: 'type-service'},
					name: 'typeServiceList',
					component: () => import('@/viewer/type-service/TypeServiceList')
				},
				{
					path: '/type-service/:id?',
					meta: { group: 'type-service'},
					name: 'typeService',
					component: () => import('@/viewer/type-service/TypeServiceForm')
				}
			]
		},
		{
			path: '',
			alias: '/',
			redirect: '/text-fragment',
			meta: { authentication: { requiresAuth: true, permissionLevel: ADMINISTRATOR } },
			component: () => import('@/Layout'),
			children: [
				{
					path: '/text-fragment/list',
					meta: { group: 'text-fragment'},
					name: 'textFragmentList',
					component: () => import('@/viewer/text-fragment/TextFragmentList')
				},
				{
					path: '/text-fragment/:id?',
					meta: { group: 'text-fragment'},
					name: 'textFragment',
					component: () => import('@/viewer/text-fragment/TextFragmentForm')
				}
			]
		},
		{
			path: '',
			alias: '/',
			redirect: '/budget-configuration',
			meta: { authentication: { requiresAuth: true, permissionLevel: ADMINISTRATOR } },
			component: () => import('@/Layout'),
			children: [
				{
					path: '/budget-configuration/list',
					meta: { group: 'budget-configuration'},
					name: 'budgetConfigurationList',
					component: () => import('@/viewer/budget-configuration/BudgetConfigurationList')
				},
				{
					path: '/budget-configuration/:id?',
					meta: { group: 'budget-configuration'},
					name: 'budgetConfiguration',
					component: () => import('@/viewer/budget-configuration/BudgetConfigurationForm')
				}
			]
		},
		{
			path: '',
			alias: '/',
			redirect: '/timeline-predefinition',
			meta: { authentication: { requiresAuth: true, permissionLevel: ADMINISTRATOR } },
			component: () => import('@/Layout'),
			children: [
				{
					path: '/timeline-predefinition/list',
					meta: { group: 'timeline-predefinition'},
					name: 'timelinePredefinitionList',
					component: () => import('@/viewer/timeline-predefinition/TimelinePredefinitionList')
				},
				{
					path: '/timeline-predefinition/:id?',
					meta: { group: 'timeline-predefinition'},
					name: 'timelinePredefinitionForm',
					component: () => import('@/viewer/timeline-predefinition/TimelinePredefinitionForm')
				}
			]
		},
		{
			path: '',
			alias: '/',
			redirect: '/quick-protocol-create',
			meta: { authentication: { requiresAuth: true, permissionLevel: ADMINISTRATOR } },
			component: () => import('@/Layout'),
			children: [
				{
					path: '/quick-protocol-create/list',
					meta: { group: 'quick-protocol-create'},
					name: 'quickProtocolCreateList',
					component: () => import('@/viewer/quickProtocol/QuickProtocolCreateList')
				},
				{
					path: '/quick-protocol-create/:id?',
					meta: { group: 'quick-protocol-create'},
					name: 'quickProtocolCreate',
					component: () => import('@/viewer/quickProtocol/QuickProtocolCreateForm')
				}
			]
		},
		{
			path: '',
			alias: '/',
			redirect: '/letter',
			meta: { authentication: { requiresAuth: true, permissionLevel: ADMINISTRATOR } },
			component: () => import('@/Layout'),
			children: [
				{
					path: '/letter/list',
					meta: { group: 'letter-create'},
					name: 'letterList',
					component: () => import('@/viewer/letter/LetterList')
				},
				{
					path: '/letter/:id?',
					meta: { group: 'letter-create'},
					name: 'LetterCreate',
					component: () => import('@/viewer/letter/LetterForm')
				}
			]
		},
		{
			path: '',
			alias: '/',
			redirect: '/contract',
			meta: { authentication: { requiresAuth: true, permissionLevel: ADMINISTRATOR } },
			component: () => import('@/Layout'),
			children: [
				{
					path: '/contract/list',
					meta: { group: 'contract-create'},
					name: 'contractList',
					component: () => import('@/viewer/contract/ContractList')
				},
				{
					path: '/contract/:id?',
					meta: { group: 'contract-create'},
					name: 'ContractCreate',
					component: () => import('@/viewer/contract/ContractForm')
				}
			]
		},
		{
			path: '',
			alias: '/',
			redirect: '/stage',
			meta: { authentication: { requiresAuth: true, permissionLevel: ADMINISTRATOR } },
			component: () => import('@/Layout'),
			children: [
				{
					path: '/stage/list',
					meta: { group: 'stage'},
					name: 'stageList',
					component: () => import('@/viewer/stage/StageList')
				},
				{
					path: '/stage/:id?',
					meta: { group: 'stage'},
					name: 'stageForm',
					component: () => import('@/viewer/stage/StageForm')
				}
			]
		},
		{
			path: '',
			alias: '/',
			redirect: '/reports/protocol-control',
			meta: { authentication: { requiresAuth: true } },
			component: () => import('@/Layout'),
			children: [
				{
					path: '/reports/protocol-control',
					meta: { group: 'reports'},
					name: 'protocolControlReport',
					component: () => import('@/viewer/reports/ProtocolControlReport')
				}
			]
		},
		{
			path: '/public-client/:protocolId',
			name: 'public-client-form',
			meta: { requiresAuth: false },
			component: PublicClientForm
		},
		{
			path: '/public-client/:protocolId/status',
			name: 'public-client-status',
			meta: { requiresAuth: false },
			component: PublicClientProtocolInfo
		},
		{
			path: '/login',
			name: 'login',
			component: Login
		},
		{
			path: '/error',
			name: 'error',
			component: Error
		},
	],
	scrollBehavior() {
		return {x: 0, y: 0};
	}
});

router.beforeEach(async (to, from, next) => {
	const authenticationList = to.matched.filter(record => record.meta.authentication);
	if(authenticationList[0] || to.meta.authentication) {
		const authentication =  to.meta.authentication ? to.meta.authentication : authenticationList[0].meta.authentication;
		const requiresAuth = authentication.requiresAuth;
		const permissionLevel = authentication.permissionLevel;

		const user = await AuthBusiness.getLoggedUser();
		if (requiresAuth && !user) {
			return next({path: '/login', query: { redirect: to.fullPath }});
		}

		if (requiresAuth && user && permissionLevel) {
			if (!isAuthorized(user, permissionLevel)) {
				return next({path: '/'});
			}
		}
	}
	
	next();
});

export const permissionsLevel = {
	'LIMITED': [LIMITED],
	'NORMAL': [LIMITED, NORMAL],
	'ADMINISTRATOR': [LIMITED, NORMAL, ADMINISTRATOR],
};

function isAuthorized(user, permissionLevel) {
	return permissionsLevel[user.typeUser].includes(permissionLevel);
}